import { useEffect, useState } from 'react';

export const useDebouncedValue = <V>(value: V, delay = 300): V => {
  const [state, setState] = useState<V>(value);

  useEffect(() => {
    const id = setTimeout(() => {
      setState(value);
    }, delay);

    return () => {
      clearTimeout(id);
    };
  }, [value, delay]);

  return state;
};
